import React, { useState } from "react";
import "../IntegrationEditor.scss";
import { FormElement, Form } from "../common/core/Form";
import Input from "../common/Input";
import Button from "../common/Button";
import SingleSelectCheckBox from "../common/SingleSelectCheckBox";
import BuzzBrokerAgentTable from "./BuzzBrokerAgentTable";

const BuzzBroker = ({
  history,
  activeFLage,
  integrationData,
  updateIntegrationApi,
  showToast,
}) => {
  const initialValues = {
    ...integrationData,
    active: activeFLage,
  };
  const [showConfig, setShowConfig] = useState(true);
  const [showAgentDetails, setShowAgentDetails] = useState(false);
  const columnName = [
    "Email ID",
    "DID Number",
    "Process Id",
    "Process Type",
    "CallBack Url",
    "Campaign",
  ];
  const updatedActiveSupportTypea = (props, flag, val) => {
    const tempArray = props.activeSupportedTypes;
    const filteredArray =
      flag === "true"
        ? tempArray.push(val)
        : tempArray?.filter((selVal) => selVal !== val);
    props.updateForm({
      activeSupportedTypes: flag === "true" ? tempArray : filteredArray,
    });
  };

  const updateEndPointsConfig = (props, key, val) => {
    const tempObj = { ...props.endPoints };
    tempObj[key] = val;
    props.updateForm({ endPoints: tempObj });
  };

  const handleSubmit = (val) => {
    updateIntegrationApi(val);
  };
  return (
    <React.Fragment>
      <Form
        onSubmit={(val) => {
          handleSubmit(val);
        }}
        initialValues={initialValues}
        canUpdateInitialValues={true}>
        <FormElement>
          {(props) => (
            <div styleName="int-base">
              <div
                styleName="info-header"
                onClick={() => {
                  setShowConfig(!showConfig);
                  setShowAgentDetails(false);
                }}>
                Configuration
                <div styleName={showConfig ? "arrow-up" : "down-arrow"} />
              </div>
              <div styleName="flex-col">
                {showConfig && (
                  <div styleName="config">
                    <div styleName="accordian-div">
                      <div styleName="accordian-text">Basic</div>
                      <div styleName="inpt-holder">
                        <div styleName="col">
                          <Input
                            placeholder="Base URL"
                            value={props.baseUrl}
                            onChange={(val) =>
                              props.updateForm({ baseUrl: val })
                            }
                            border="1px solid #e3e3e3d9"
                          />
                        </div>
                        <div styleName="col">
                          <Input
                            placeholder="Website URL"
                            value={props.websiteUrl}
                            onChange={(val) =>
                              props.updateForm({ websiteUrl: val })
                            }
                            border="1px solid #e3e3e3d9"
                          />
                        </div>
                        <div styleName="col">
                          <Input
                            placeholder="Image URL"
                            value={props.image}
                            onChange={(val) => props.updateForm({ image: val })}
                            border="1px solid #e3e3e3d9"
                          />
                        </div>
                      </div>
                    </div>
                    {props.endPoints &&
                      Object.keys(props.endPoints)?.length > 0 && (
                        <div styleName="accordian-div">
                          <div styleName="accordian-text">End Points</div>
                          <div styleName="inpt-holder">
                            {Object.keys(props.endPoints)?.map((key, i) => {
                              return (
                                <div styleName="col" key={i}>
                                  <Input
                                    placeholder={key}
                                    value={props.endPoints[key]}
                                    onChange={(val) =>
                                      updateEndPointsConfig(props, key, val)
                                    }
                                    border="1px solid #e3e3e3d9"
                                  />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    {props.supportedTypes?.length > 0 && (
                      <div styleName="accordian-div">
                        <div styleName="accordian-text">Supported Types</div>
                        <div styleName="other">
                          <div styleName="flex-wrap">
                            {props.supportedTypes?.map((val, _i) => (
                              <div styleName="ele" key={_i}>
                                <SingleSelectCheckBox
                                  options={[{ label: val, value: "true" }]}
                                  selected={
                                    props.activeSupportedTypes?.includes(val)
                                      ? "true"
                                      : false
                                  }
                                  onSelect={(flag) => {
                                    updatedActiveSupportTypea(props, flag, val);
                                  }}
                                  fontSize="14px"
                                  tabIndex="0"
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div
                  styleName="info-header"
                  onClick={() => {
                    setShowAgentDetails(!showAgentDetails);
                    setShowConfig(false);
                  }}>
                  Agent Details
                  <div
                    styleName={showAgentDetails ? "arrow-up" : "down-arrow"}
                  />
                </div>
                {showAgentDetails && (
                  <BuzzBrokerAgentTable
                    providerId={integrationData?.id}
                    history={history}
                    columnName={columnName}
                    showToast={showToast}
                  />
                )}
              </div>
              <div styleName="footer-button">
                <Button
                  type="secondary"
                  label="Go Back"
                  onClick={() => history.goBack()}
                />
                <Button
                  margin="0 10px 0 10px"
                  label="Save"
                  onClick={() => props.onSubmit()}
                />
              </div>
            </div>
          )}
        </FormElement>
      </Form>
    </React.Fragment>
  );
};

export default BuzzBroker;
